module.exports = __webpack_public_path__ + "img/bind-failure.db292783.png";